import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import InputField from '../shared/InputField';
import countryList from '../../utils/country_list';
import { getClassName, checkButtonDisabled } from '../../utils/forms';

export default class NewOrderFormOne extends React.Component {
  static propTypes = {
    invalid: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    submitFunction: PropTypes.func.isRequired,
    cancelOrderFunction: PropTypes.func.isRequired,
    escapeForm: PropTypes.func.isRequired,
    dirty: PropTypes.bool.isRequired,
  };

  renderCountrySelect = ({ input, label, meta: { touched, error } }) => (
    <div className={getClassName(touched, error)}>
      <label htmlFor="country-select" className="form-control-label">
        {label} {touched && error && <span> | {error} </span>}
      </label>
      <div className="form-group row">
        <div className="col-md-6">
          <select {...input} id="country-select" className="form-control form-control-success">
            <option />
            {countryList.map(this.renderCountries)}
          </select>
        </div>
      </div>
    </div>
  );

  renderCountries = country => (
    <option key={country.key} value={country.name}>
      {country.name}
    </option>
  );

  render() {
    const { invalid, submitting, submitFunction, escapeForm, dirty } = this.props;

    return (
      <div className="modal-wrap">
        <div className="container-fluid container-home">
          <div className="header">
            <div className="header-body">
              <div className="row">
                <div className="col-sm-12">
                  <h1 className="header-title">New Order</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="card-border">
                <div className="card-header">
                  <div className="card-header-title">Customer Details</div>
                </div>
                <div className="card-block">
                  <form>
                    <fieldset>
                      <Field
                        name="companyName"
                        type="text"
                        component={InputField}
                        label="Company Name"
                        placeholder="Enter customer company name"
                        autoFocus
                      />
                      <div className="form-group row">
                        <div className="col-md-6">
                          <Field
                            name="providerCustomerNumber"
                            type="text"
                            component={InputField}
                            label="Customer number"
                            placeholder="Enter customer number"
                          />
                        </div>
                        <div className="col-md-6">
                          <Field
                            name="providerOrderNumber"
                            type="text"
                            component={InputField}
                            label="Order Number"
                            placeholder="Enter order number"
                          />
                        </div>
                      </div>
                      <Field
                        name="companyPhone"
                        type="text"
                        component={InputField}
                        label="Company Phone"
                        placeholder="111-111-1111"
                      />
                      <Field
                        name="addressLine1"
                        type="text"
                        component={InputField}
                        label="Address Line 1"
                        placeholder="Enter Address"
                      />
                      <Field
                        name="addressLine2"
                        type="text"
                        component={InputField}
                        label="Address Line 2"
                        placeholder="Enter Address"
                      />
                      <Field name="country" component={this.renderCountrySelect} label="Country" />
                      <div className="form-group row">
                        <div className="col-md-4">
                          <Field
                            name="city"
                            type="text"
                            component={InputField}
                            label="City"
                            placeholder="Enter city"
                          />
                        </div>
                        <div className="col-md-4">
                          <Field
                            name="state"
                            type="text"
                            component={InputField}
                            label="State"
                            placeholder="Enter state"
                          />
                        </div>
                        <div className="col-md-4">
                          <Field
                            name="zipCode"
                            type="text"
                            component={InputField}
                            label="Zip"
                            placeholder="Enter zip code"
                          />
                        </div>
                      </div>
                      <div className="form-buttons">
                        <p className="pull-right">
                          <button
                            type="button"
                            className="btn btn-secondary btn-back"
                            onClick={() => escapeForm(dirty)}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={submitFunction}
                            disabled={checkButtonDisabled(invalid, submitting)}
                          >
                            Continue
                          </button>
                        </p>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
